import script from "./WidgetSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./WidgetSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./WidgetSidebar.vue?vue&type=style&index=0&id=3f764778&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f764778"]])

export default __exports__